import { render, staticRenderFns } from "./ArrowDown.vue?vue&type=template&id=3d88dd6c&scoped=true&"
import script from "./ArrowDown.vue?vue&type=script&lang=ts&"
export * from "./ArrowDown.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowDown.vue?vue&type=style&index=0&id=3d88dd6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88dd6c",
  null
  
)

export default component.exports